import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
import { countdown } from '../../common/format';
export default class GiveawayCard extends Component {
  view() {
    const g = this.attrs.giveaway;
    const active = g.status === 'active';
    return m(Link, {
      className: "GiveawayCard",
      href: app.route('giveaways.show', {
        slug: g.slug
      })
    }, m("div", {
      className: 'GiveawayCard-cover' + (g.coverUrl ? '' : ' GiveawayCard-cover--placeholder'),
      style: g.coverUrl ? {
        backgroundImage: "url(\"".concat(g.coverUrl, "\")")
      } : undefined
    }, !g.coverUrl && m(Icon, {
      name: "fas fa-gift"
    }), m("span", {
      className: "GiveawayCard-status GiveawayCard-status--".concat(g.status)
    }, app.translator.trans("ernestdefoe-giveaways.forum.status_".concat(g.status)))), m("div", {
      className: "GiveawayCard-body"
    }, g.category && m("span", {
      className: "GiveawayCard-category",
      style: {
        color: g.category.color
      }
    }, g.category.icon && m(Icon, {
      name: g.category.icon
    }), " ", g.category.name), m("h3", {
      className: "GiveawayCard-title"
    }, g.title), m("div", {
      className: "GiveawayCard-prize"
    }, m(Icon, {
      name: "fas fa-trophy"
    }), " ", g.prize), m("div", {
      className: "GiveawayCard-meta"
    }, m("span", null, m(Icon, {
      name: "fas fa-clock"
    }), ' ', active ? app.translator.trans('ernestdefoe-giveaways.forum.ends_in', {
      time: countdown(g.endsAt)
    }) : app.translator.trans('ernestdefoe-giveaways.forum.ended')), m("span", null, m(Icon, {
      name: "fas fa-users"
    }), ' ', app.translator.trans('ernestdefoe-giveaways.forum.entrants', {
      count: g.entrantCount
    }))), g.myEntries > 0 && m("div", {
      className: "GiveawayCard-entered"
    }, m(Icon, {
      name: "fas fa-check-circle"
    }), ' ', app.translator.trans('ernestdefoe-giveaways.forum.your_entries', {
      count: g.myEntries
    }))));
  }
}
flarum.reg.add('ernestdefoe-giveaways', 'forum/components/GiveawayCard', GiveawayCard);